import Box from '@mui/material/Box';
// import { headerHeight, headerHeightMb } from '~/styles';
import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { BrowserRouter as Router } from 'react-router-dom';
import { Ecosystem, ecosystemBG, skillsgraphmobile } from '~/assets';
import { line } from '~/assets';
import { makeStyles } from '@material-ui/core/styles';

export const EcosystemFriendly = () => {
  const useStyles = makeStyles((theme) => ({
    root:{
      backgroundImage: `url(${ecosystemBG})`,
      backgroundRepeat: 'no-repeat',
      // marginTop: "-0px",
      [theme.breakpoints.up('lg')]:{
        backgroundImage: 'none'
      },
      backgroundSize:"cover",
      
      
    },

    desktop: {
      display: "none",
        [theme.breakpoints.up("lg")]: {
          display: "flex",
        },
    },
    
    mobile:{
      display:'flex',
      [theme.breakpoints.up("lg")]: {
        display: "none",
      },
    }, 
    image:{
      [theme.breakpoints.down(350)]: {
        width:'95%'
      },
    }

  }));

  const classes = useStyles();
  return (
    <Box maxWidth="1400px" width='100%' align-item="center" display="flex" justifyContent="center" flexDirection="column">
      <Box className={classes.root} marginTop={10} id="ecosystem">
        <Box marginX={{xs:2, lg:20, xl:1}}>
        <Grid container>
          <Grid item xs={12} lg={4}>
            <Box textAlign={{ lg: 'left', xs: 'center', md: 'left' }}
            marginBottom={{xs:5, lg:0}}
            >
              <Box>
                <Typography variant="h5"
                style={{
                  backgroundColor:"#F69501",
                  backgroundImage: 'linear-gradient(268.99deg, #F69501 0.03%, #F1756E 100.53%)',
                  WebkitTextFillColor:'transparent',
                  backgroundClip:'text',
                  WebkitBackgroundClip:'text'
                }}
                fontSize={{xs:'12px', md:'16px'}}
                lineHeight={{xs:'18px', md:'26px'}}
                letterSpacing='0.2rem'
                >
                  ECOSYSTEM
                </Typography>
              </Box>
              <Box display='flex' justifyContent={'center'} flexDirection={{lg:'column', xs:'row'}}>
                <Typography fontSize={{xs:'24px', lg:'40px'}} mt={{lg:2, xs:0}} variant="h6">
                  A friendly
                </Typography>
                <Typography fontSize={{xs:'24px', lg:'40px'}} ml={{lg:0, xs: 0.8}} variant="h6">ecosystem</Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} lg={8}>
            <Box textAlign={{xs:'center', lg: 'left'}} marginBottom={10}>
              <Box>
                <Typography variant="body2" fontSize={{lg:'16px', xs: '14px'}} lineHeight='26px'>
                  Skillsbite employs learn to earn model incentivising actions
                  and renumerating its stakeholders for learning, helping others
                  and contributing to the ecosystem. The value-added community
                  is achieved through an all-in-one platform that empowers its
                  users and creates a friendly environment for them to help
                  themselves grow as well as help others do the same.
                </Typography>
              </Box>
              <Box sx={{ marginTop: '30px' }}>
                <Typography variant="body2" fontSize={{lg:'16px', xs: '14px'}} lineHeight='26px'>
                  Our team has designed a set of three technological and social
                  solutions to facilliate for the process of knowledge creation
                  in current economy.
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            lg={12}
            
            justifyContent="center"
            alignContent="center"
            className={classes.desktop}
          >
            <img src={line} alt="line" width="100%" />
          </Grid>

          <Grid
            item
            xs={12}
            lg={12}
            // marginX={10}
            
            justifyContent="center"
            alignContent="center"
            className={classes.desktop}
          >
            <img src={Ecosystem} alt="graph" width="100%" height="100%" />
          </Grid>

          <Grid
          item
          xs={12}
          className={classes.mobile}
          justifyContent='center'
          mb={10}
          paddingX={2}
          >
            <img className={classes.image} src={skillsgraphmobile} alt="graph"/>
          </Grid>

        </Grid>
        </Box>
      </Box>
    </Box>
  );
};
